export default __webpack_public_path__ + "static/media/profile.9eb20ae4.svg";